import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../../utils/resolveProps'
import { LinkDetailsProps }  from './types'

const config = {
  types: ['inverse'],
  modifiers: [],
  states: []
}

const renderLinkDetailsGroup = (data) => {
  const listItems = data?.map((link, index) => (
    <div key={index} className="mdn-LinkDetails-group">
      <div className="mdn-Link mdn-Link--arrow">
        <a
          {...link.linkProps}
          className="mdn-Link-anchor"
          target={link.target}
          href={link.href}
        >
          {link.title}
        </a>
        <span className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--md"></span>
      </div>
      <p className="mdn-Text mdn-Text--caption">{link.description}</p>
    </div>
  ))
  return listItems
}
export default function LinkDetails(props: LinkDetailsProps) {
  const { data, inverse, ...rest } = props

  return (
    <div {...rest} className={resolveProps(props, config, 'LinkDetails')}>
      {renderLinkDetailsGroup(data)}
    </div>
  )
}
